"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _customProps = require("../../utils/customProps");

var _Grid = _interopRequireDefault(require("../../components/PageGrid/templates/Grid/Grid"));

var _GridItem = _interopRequireDefault(require("../../components/PageGrid/templates/GridItem/GridItem"));

// atoms
var Icon = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/atoms/Icon/Icon"));
  });
});
var Image = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/atoms/Image/Image"));
  });
});
var Video = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/atoms/Video/Video"));
  });
}); // molecules

var Typography = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/molecules/Typography/Typography"));
  });
});
var ButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/molecules/ButtonDownload/ButtonDownload"));
  });
});
var ButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/molecules/ButtonRedirect/ButtonRedirect"));
  });
});
var IconButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/molecules/IconButtonDownload/IconButtonDownload"));
  });
});
var IconButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/molecules/IconButtonRedirect/IconButtonRedirect"));
  });
}); // organisms

var Accordion = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/Accordion/Accordion"));
  });
});
var ActionCardContainer = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/ActionCardContainer/ActionCardContainer"));
  });
});
var AudioPlayer = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/AudioPlayer/AudioPlayer"));
  });
});
var Card = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/Card/Card"));
  });
});
var GridList = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/GridList/GridList"));
  });
});
var List = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/List/List"));
  });
});
var ListDropdown = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/ListDropdown/ListDropdown"));
  });
});
var MusicCard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/MusicCard/MusicCard"));
  });
});
var ReviewCard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/ReviewCard/ReviewCard"));
  });
});
var PostCard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/PostCard/PostCard"));
  });
});
var PricingCard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/PricingCard/PricingCard"));
  });
});
var StyledList = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/organisms/StyledList/StyledList"));
  });
}); // templates

var AppBar = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/templates/AppBar/AppBar"));
  });
});
var ButtonDialog = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/templates/ButtonDialog/ButtonDialog"));
  });
});
var ButtonDrawer = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/templates/ButtonDrawer/ButtonDrawer"));
  });
});
var Form = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/templates/Form/Form"));
  });
});
var GeoLocationMobileStepper = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/templates/GeoLocationMobileStepper/GeoLocationMobileStepper"));
  });
});
var GeoLocationTabs = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/templates/GeoLocationTabs/GeoLocationTabs"));
  });
});
var IconButtonDialog = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/templates/IconButtonDialog/IconButtonDialog"));
  });
});
var IconButtonDrawer = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/templates/IconButtonDrawer/IconButtonDrawer"));
  });
});
var MobileStepper = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/templates/MobileStepper/MobileStepper"));
  });
});
var NotificationBanner = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/templates/NotificationBanner/NotificationBanner"));
  });
});
var Tabs = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../components/PageGrid/templates/Tabs/Tabs"));
  });
});
var components = {
  Icon: Icon,
  Image: Image,
  Video: Video,
  Typography: Typography,
  ButtonDownload: ButtonDownload,
  ButtonDrawer: ButtonDrawer,
  Form: Form,
  GeoLocationMobileStepper: GeoLocationMobileStepper,
  GeoLocationTabs: GeoLocationTabs,
  ButtonRedirect: ButtonRedirect,
  IconButtonDownload: IconButtonDownload,
  IconButtonRedirect: IconButtonRedirect,
  Accordion: Accordion,
  ActionCardContainer: ActionCardContainer,
  AudioPlayer: AudioPlayer,
  Card: Card,
  GridList: GridList,
  List: List,
  ListDropdown: ListDropdown,
  MusicCard: MusicCard,
  ReviewCard: ReviewCard,
  PostCard: PostCard,
  PricingCard: PricingCard,
  StyledList: StyledList,
  AppBar: AppBar,
  ButtonDialog: ButtonDialog,
  IconButtonDialog: IconButtonDialog,
  IconButtonDrawer: IconButtonDrawer,
  MobileStepper: MobileStepper,
  NotificationBanner: NotificationBanner,
  Tabs: Tabs,
  PageGridItem: _GridItem.default
};

var PageGrid = function PageGrid(props) {
  return /*#__PURE__*/_react.default.createElement(_Grid.default, (0, _extends2.default)({}, props, {
    components: components
  }));
};

var _default = PageGrid;
exports.default = _default;
PageGrid.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component. See CSS API below for more details.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: 'stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around'
   * Defines the align-content style property. It's applied for all screen sizes.
   */
  alignContent: function alignContent(props, propName, componentName) {
    var validProp = ['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop: 'flex-start' , 'center' , 'flex-end' , 'stretch' , 'baseline'
   * Defines the align-items style property. It's applied for all screen sizes.
   */
  alignItems: function alignItems(props, propName, componentName) {
    var validProp = ['flex-start', 'center', 'flex-end', 'stretch', 'baseline'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /*
  * mui prop: 'row', 'row-reverse', 'column', 'column-reverse'
  * Defines the flex-direction style property. It is applied for all screen sizes.
  */
  direction: function direction(props, propName, componentName) {
    var validProp = ['row', 'row-reverse', 'column', 'column-reverse'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop:
   * 'flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'
   * Defines the justify-content style property. It is applied for all screen sizes.
   */
  justify: function justify(props, propName, componentName) {
    var validProp = ['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop:  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10
   * Defines the space between the type item
   component. It can only be used on a type container component.
   */
  spacing: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * mui prop: 'nowrap', 'wrap', 'wrap-reverse'
   * Defines the flex-wrap style property. It's applied for all screen sizes.
   */
  wrap: function wrap(props, propName, componentName) {
    var validProp = ['nowrap', 'wrap', 'wrap-reverse'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * Content passed to render
   */
  content: _propTypes.default.arrayOf(_propTypes.default.shape({
    component: _propTypes.default.string.isRequired
  })).isRequired,

  /** style obj to pass to grid */
  style: _propTypes.default.shape()
};
PageGrid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'center',
  rootClass: [],
  direction: 'row',
  justify: 'center',
  spacing: '2',
  wrap: 'wrap',
  style: {}
};